import React from 'react';
export const Footer = () => {
  return <footer className="bg-limestone-900 text-gray-300 py-12" data-id="element-336">
      <div className="container mx-auto px-6" data-id="element-337">
        <div className="flex flex-col md:flex-row justify-between mb-12" data-id="element-338">
          <div className="mb-8 md:mb-0" data-id="element-339">
            <div className="font-serif text-2xl font-bold text-white tracking-wider mb-4" data-id="element-340">
              EPA
            </div>
            <p className="max-w-xs font-light" data-id="element-341">
              The Elite Planners Association is the premier network for top
              South Asian wedding planners in North America and Latin America.
            </p>
            <p className="mt-4 text-limestone-300 italic font-light" data-id="element-342">
              "Better Together"
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:w-2/3" data-id="element-343">
            <div data-id="element-344">
              <h3 className="text-white font-serif font-bold mb-4" data-id="element-345">
                Our Mission
              </h3>
              <p className="text-gray-400 mb-4" data-id="element-346">
                We celebrate the visionaries who set new standards in
                creativity, cultural expertise, and seamless execution —
                ensuring every celebration is extraordinary. Our mission is to
                spotlight industry leaders who elevate South Asian weddings
                across the globe.
              </p>
            </div>
            <div data-id="element-347">
              <h3 className="text-white font-serif font-bold mb-4" data-id="element-348">
                Our Vision
              </h3>
              <p className="text-gray-400 mb-4" data-id="element-349">
                We foster a community that inspires collaboration, innovation,
                and growth within the luxury wedding industry. Together, we
                raise the bar for unforgettable experiences that honor culture
                and redefine excellence.
              </p>
            </div>
          </div>
        </div>
        <div className="border-t border-limestone-800 pt-8 mt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-350">
          <p className="font-light" data-id="element-351">
            &copy; {new Date().getFullYear()} Elite Planners Association. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};